<script lang="ts">
	import { fly, fade } from 'svelte/transition'
	import Portal from 'svelte-portal'

	let {
		children,
		open = $bindable(),
		close,
		player = undefined,
		title = undefined,
		small = undefined,
		dialog = undefined,
		split = undefined
	} = $props()
</script>

{#if open}
	<Portal target=".main">
		<button class="overlay" aria-label="Close" onclick={close} transition:fade></button>
		<div
			class="modal theme-crocus-on-gimson"
			class:player
			class:small
			class:dialog
			class:split
			in:fly={{ y: 100, delay: 300 }}
			out:fly={{ y: 100 }}
		>
			<div class="head" class:player>
				{#if !player && title && !dialog}
					<div class="title">{title}</div>
				{/if}
				{#if !dialog}
					<button class="close" class:player aria-label="Close" form="close" onclick={close}>
						<svg class="svg" viewBox="0 0 24 24" fill="none">
							<path d="M20 4L4 20" stroke="currentColor" stroke-width="1.5" />
							<path d="M4 4L20 20" stroke="currentColor" stroke-width="1.5" />
						</svg>
					</button>
				{/if}
			</div>
			<div class="content" class:player class:dialog class:split>
				{#if dialog}
					<div class="title dialog">{title}</div>
				{/if}
				{@render children()}
			</div>
		</div>
	</Portal>
{/if}

<style lang="css">
	.overlay {
		background-color: hsl(39 30% 3% / 0.8);
		inset: 0;
		position: fixed;
		z-index: 99;
	}

	.modal {
		background-color: var(--c-gimson);
		inset: auto auto 0 auto;
		max-height: 90vh;
		max-width: var(--s-wrap);
		overflow: auto;
		position: fixed;
		transition:
			opacity 0.25s ease,
			scale 0.25s ease,
			translate 0.25s ease;
		width: 100%;
		z-index: 100;
		will-change: transform;

		@media (--from-mobile) {
			inset: calc(50% + 4rem) auto auto 50%;
			translate: -50% -50%;
		}

		&.player {
			aspect-ratio: 16/9;
			background: none;
			inset: 50% auto auto 50%;
			overflow: visible;
			translate: -50% -50%;
		}

		&.small {
			max-width: 40rem;
		}

		&.dialog {
			max-width: 38rem;
		}

		&.split {
			max-width: var(--s-wrap);

			@media (--from-mobile) {
				width: 90vw;
			}
		}
	}

	.head {
		position: sticky;
		top: 0;
		z-index: 1;

		&.player {
			display: contents;
		}
	}

	.title {
		background-color: var(--c-white);
		font: 500 var(--f-h6);
		padding: 1.5rem 2rem;
		text-transform: uppercase;

		&.dialog {
			background: none;
			font: 500 var(--f-h4);
			letter-spacing: var(--ls-h4);
			padding: 0;
			text-align: center;
			text-transform: none;
		}
	}

	.close {
		display: grid;
		inset: 0 0 auto auto;
		place-items: center;
		position: absolute;
		size: 4.5rem;
		transition:
			background-color 0.25s ease,
			color 0.25s ease,
			scale 0.25s ease;
		z-index: 1;

		&.player {
			background-color: var(--c-charcoal);
			border-radius: 50%;
			color: var(--c-gimson);
			size: 3rem;
			translate: -0.125rem -1.75rem;

			@media (--from-mobile) {
				size: 3.5rem;
				translate: 1.25rem -1.25rem;
			}
		}

		&:hover {
			&.player {
				color: var(--c-white);
			}
		}

		&:active {
			scale: 0.9;

			&.player {
				background-color: black;
			}
		}
	}

	.svg {
		size: 1.5rem;
	}

	.content {
		font: 400 var(--f-body1);
		letter-spacing: var(--ls-body1);
		padding: 2rem;

		&.player {
			margin-inline: 6vw;
			padding: 0;

			@media (--from-mobile) {
				margin-inline: 0;
			}
		}

		&.dialog {
			display: grid;
			gap: 1rem;
			text-align: center;
		}

		&.split {
			display: grid;

			@media (--from-mobile) {
				gap: 2.5rem;
				grid-template-columns: minmax(0, 8fr) minmax(0, 4fr);
			}

			:global(.quotes) {
				grid-column: 1 / -1;
			}
		}
	}
</style>
